import {marked} from 'marked'
import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import {StyledTypography} from './MarkdownRendererStyles'

marked.options({breaks: true})
// Utility function to format key-value pairs into Markdown
const formatKeyValuePairs = (obj) => {
  let formattedMarkdown = ''
  for (const [key, value] of Object.entries(obj)) {
    formattedMarkdown += `**${key}:** ${value}\n`
  }
  return formattedMarkdown
}

// Utility function to process JSON content
const processJsonContent = (formattedMarkdown, jsonContent) => {
  if (Array.isArray(jsonContent)) {
    for (const item of jsonContent) {
      formattedMarkdown += formatKeyValuePairs(item)
    }
  } else if (typeof jsonContent === 'object' && jsonContent !== null) {
    formattedMarkdown += formatKeyValuePairs(jsonContent)
  }
  return formattedMarkdown
}

export const preprocessMarkdown = (text) => {
  const formattedText = marked.lexer(text)
  let formattedMarkdown = ''
  for (const token of formattedText) {
    if (token.type === 'code' && token.lang === 'json') {
      // If the token is a code block with JSON language, parse it
      try {
        const jsonContent = JSON.parse(token.text)
        formattedMarkdown += processJsonContent(formattedMarkdown, jsonContent)
      } catch (error) {
        console.error('Error parsing JSON:', error)
        return text // Return the original text in case of an error
      }
    } else {
      // If the token is a paragraph, return it as is
      formattedMarkdown += token.raw
    }
  }
  return `${formattedMarkdown}`
}

const MarkdownRenderer = ({markdownText, sender}) => {
  const processedMarkdown = preprocessMarkdown(markdownText)

  return (
    <StyledTypography
      sender={sender}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(marked(processedMarkdown))
      }}
    />
  )
}

MarkdownRenderer.propTypes = {
  markdownText: PropTypes.string.isRequired,
  sender: PropTypes.string
}

export default MarkdownRenderer
